"use strict";

exports.__esModule = true;
exports.Breadcrumbs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _history = require("history");
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _excluded = ["breadcrumbs", "className"],
  _excluded2 = ["to", "onClick"];
var _class, _Breadcrumbs;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BreadcrumbButton = _styledComponents["default"].button.withConfig({
  displayName: "Breadcrumbs__BreadcrumbButton",
  componentId: "sc-4vbtk7-0"
})(["margin:0;padding:0;border:none;text-align:left;font-size:16px;line-height:19px;background-color:transparent;cursor:pointer;&:hover{text-decoration:underline;}&:focus{outline:none;}"]);

/**
 * Simple breadcrumbs.
 */
var Breadcrumbs = exports.Breadcrumbs = (0, _reactRouterCompat.withRouter)(_class = (_Breadcrumbs = /*#__PURE__*/function (_Component) {
  function Breadcrumbs() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderItem = function (_ref, index) {
      var text = _ref.text,
        to = _ref.to,
        className = _ref.className,
        onClick = _ref.onClick;
      var breadcrumbs = _this.props.breadcrumbs;
      var isLast = index === breadcrumbs.length - 1;
      if (isLast) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: (0, _classnames["default"])(_core.Classes.BREADCRUMB, _core.Classes.BREADCRUMB_CURRENT, className)
        }, text);
      } else if (to !== undefined) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: to,
          onClick: onClick,
          className: (0, _classnames["default"])(_core.Classes.BREADCRUMB, className)
        }, text);
      }
      return /*#__PURE__*/_react["default"].createElement(BreadcrumbButton, {
        onClick: onClick,
        className: (0, _classnames["default"])(_core.Classes.BREADCRUMB, className)
      }, text);
    };
    return _this;
  }
  _inheritsLoose(Breadcrumbs, _Component);
  var _proto = Breadcrumbs.prototype;
  _proto.createClickHandler = function createClickHandler(to) {
    var _this2 = this;
    return function (e) {
      e.preventDefault();
      if (to === undefined) {
        return;
      }
      var history = _this2.props.history;
      history.push(to);
    };
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      breadcrumbs = _this$props.breadcrumbs,
      className = _this$props.className,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_core.CollapsibleList, _extends({
      visibleItemCount: 2,
      className: (0, _classnames["default"])(className, _core.Classes.BREADCRUMBS),
      visibleItemRenderer: this.renderItem,
      dropdownTarget: /*#__PURE__*/_react["default"].createElement("span", {
        className: _core.Classes.BREADCRUMBS_COLLAPSED
      })
    }, extra), breadcrumbs.map(function (_ref2, index) {
      var to = _ref2.to,
        onClick = _ref2.onClick,
        crumb = _objectWithoutPropertiesLoose(_ref2, _excluded2);
      return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, _extends({
        key: String(index),
        onClick: typeof onClick === "function" ? onClick : _this3.createClickHandler(to)
      }, crumb));
    }));
  };
  return Breadcrumbs;
}(_react.Component), _Breadcrumbs.defaultProps = {
  history: undefined
}, _Breadcrumbs)) || _class;